import Vue from 'vue'
import Vuex from 'vuex'
import RegisterOrganizationUsers from '@/pages/System/Admin/RegisterOrganizationUsers/store'
import Login from '@/pages/Login/store'
import Composition from '@/pages/System/Register/Composition/store'
import Input from '@/pages/System/Register/Input/store'
import InputGroup from '@/pages/System/Register/InputGroup/store'
import CompositionGroup from '@/pages/System/Register/CompositionGroup/store'
import BudgetService from '@/pages/System/Budget/Service/store'
import BudgetPhysicalSchedule from '@/pages/System/Budget/PhysicalSchedule/store'
import BudgetFinancialSchedule from '@/pages/System/Budget/FinancialSchedule/store'
import Cost from '@/pages/System/Budget/Cost/store'
import FormingPrice from '@/pages/System/Budget/FormingPrice/store'
import Role from '@/pages/System/System/Role/store'
import VuexPersistence from 'vuex-persist'
//import ReportInputPerStage from '@/pages/System/Report/InputPerStage/store'
import ReportStage from '@/pages/System/Report/Stage/store'
import ReportComposition from '@/pages/System/Report/Composition/store'
import ReportInput from '@/pages/System/Report/Input/store'
import PhysicalProgress from '@/pages/System/PhysicalProgress/PhysicalProgress/store'
import PhysicalSchedule from '@/pages/System/CostControl/PhysicalSchedule/store'
import FinancialSchedule from '@/pages/System/CostControl/FinancialSchedule/store'
import Contractor from '@/pages/System/PhysicalProgress/Contractor/store'
import OrderService from '@/pages/System/PhysicalProgress/OrderService/store'
import Metering from './pages/System/PhysicalProgress/Metering/store'
import MeteringMop from './pages/System/PhysicalProgress/MeteringMop/store'
import MeteringDetached from './pages/System/PhysicalProgress/MeteringDetached/store'
import RelatorioControleInsumos from './pages/System/Report/ControleDeInsumos/store'
import Service from './pages/System/Register/Service/store'
import ServiceGroup from './pages/System/Register/ServiceGroup/store'
import ExpensePaid from './pages/System/Report/ControleDeInsumos/ExpensePaid/store'
import Dashboard from './pages/System/Dashboard/store'
import Configuration from './pages/System/System/Configuration/store'
import IndexingSpreadsheet from './pages/System/CostControl/IndexingSpreadsheet/store'
Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        Dashboard,
        RegisterOrganizationUsers,
        Login,
        Composition,
        Input,
        InputGroup,
        CompositionGroup,
        BudgetService,
        BudgetPhysicalSchedule,
        BudgetFinancialSchedule,
        FormingPrice,
        Cost,
        Role,
        ReportStage,
        ReportComposition,
        ReportInput,
        PhysicalProgress,
        Contractor,
        OrderService,
        Metering,
        MeteringDetached,
        RelatorioControleInsumos,
        Service,
        ServiceGroup,
        MeteringMop,
        ExpensePaid,
        Configuration,
        PhysicalSchedule,
        FinancialSchedule,
        IndexingSpreadsheet,
    },
    plugins: [new VuexPersistence().plugin]
})

export { store }
